const cards = document.querySelectorAll('.process-line-card');

// Initialize a counter variable
let counter = 1;

// Loop through each card and set the counter
cards.forEach(card => {
    // Create a new element for the counter
    const counterElement = document.createElement('div');
    counterElement.classList.add('process-line-card-counter');
    counterElement.textContent = counter;

    // Append the counter element to the card
    card.appendChild(counterElement);

    // Increment the counter for the next card
    counter++;
});

// Get a reference to the parent element with the class 'process-line__wrap--outer'
var outerWrap = document.querySelector('.process-line__wrap--outer');

// Get all elements with the class 'process-line__wrap--inner' or 'process-line__wrap--inner-flip' inside the parent
if (outerWrap !== null) {
  var allInnerElements = outerWrap.querySelectorAll('.process-line__wrap--inner, .process-line__wrap--inner-flip');
  
  // Add the class 'last' to the last element
  var lastElement = allInnerElements[allInnerElements.length - 1];
  lastElement.classList.add('last');
}